import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import {useBedienerStore} from '@/store/bediener';
import Loading from '@/components/Loading.vue';
import {computed} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBediener',
  props: {
    modelValue: {},
    showLabel: { type: Boolean },
    disabled: { type: Boolean },
    skipped: {}
  },
  emits: {'update:modelValue': (data: string) => typeof data === 'string'},
  setup(__props: any, { expose: __expose, emit: __emit }) {

const store = useBedienerStore();
store.fetch().catch(console.error);
const props = __props;

const emit = __emit;

const internalValue = computed({
  get() {
    return props.modelValue || '';
  },
  set(newVal: string) {
    emit('update:modelValue', newVal);
    return;
  },
});

const filteredItems = computed(
    () => store.data.filter((bediener) => !props.skipped ||!props.skipped[bediener.Kuerzel] || bediener.Kuerzel === props.modelValue).map((s) => {
      return {Kuerzel: s.Kuerzel, Name: `${s.Name} (${s.Kuerzel})`};
    }),
);

__expose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  Error,
  filteredItems,
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_unref(store).error)
    ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        type: "error",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "grow" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Fehler: " + _toDisplayString(_unref(store).error.message), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "shrink" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _unref(store).fetch,
                    size: "small",
                    loading: _unref(store).loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Erneut versuchen")
                    ], undefined, true),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }))
    : (_unref(store).loading)
      ? (_openBlock(), _createBlock(Loading, { key: 1 }))
      : (_openBlock(), _createBlock(_component_v_select, _mergeProps({ key: 2 }, _ctx.$attrs, {
          "single-line": !_ctx.showLabel,
          density: !_ctx.showLabel ? 'compact' : 'default',
          label: "Bediener",
          modelValue: internalValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          "item-title": "Name",
          "item-value": "Kuerzel",
          items: filteredItems.value,
          loading: _unref(store).loading,
          disabled: _ctx.disabled,
          placeholder: "--- Bediener wählen ---"
        }), null, 16, ["single-line", "density", "modelValue", "items", "loading", "disabled"]))
}
}

})